module.exports = __webpack_public_path__ + "static/media/aljazirah.284e7937.webp";